export enum EntityOwnerPersonWorkTimeType {
    FullTime = 1,
    PartTime = 2,
}
